import React, { useState } from 'react'
import { Modal, Form, Input } from 'semantic-ui-react'
import styled from 'styled-components'
import { FlexRowBetween } from 'components'
import { X } from 'phosphor-react'
import { SubmitCancelButtons } from 'elements/Button'

const StyledModal = styled(Modal)`
    .ui.modal > .actions {
        padding: 1rem !important;
        
        @media (max-width: 767px) {
            padding: 1rem !important;
            padding-bottom: 2rem !important;
            margin-bottom: 0 !important;
        }
    }
    
    .ui.modal > .content {
        padding: 1.5rem !important;
        
        @media (max-width: 767px) {
            padding: 1rem !important;
        }
    }
`

const TemplateNameModal = ({ open, onClose, onSubmit, loading }) => {
    const [templateName, setTemplateName] = useState('')
    const [error, setError] = useState('')

    const handleSave = () => {
        if (!templateName.trim()) {
            setError('Template Name is required')
            return
        }
        setError('')
        onSubmit(templateName.trim())
    }

    const handleClose = () => {
        setTemplateName('')
        setError('')
        onClose()
    }

    return (
        <StyledModal open={open} onClose={handleClose} size="tiny" className="model">
            <Modal.Header>
                <FlexRowBetween>
                    <span>Create Template</span>
                    <X className="pointer" size={32} onClick={handleClose} />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.Field error={!!error}>
                        <label>Template Name</label>
                        <Input
                            placeholder="Enter template name"
                            value={templateName}
                            onChange={(_, { value }) => setTemplateName(value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    e.preventDefault()
                                    handleSave()
                                }
                            }}
                            autoFocus
                        />
                        {error && (
                            <div style={{ color: 'red', marginTop: 4 }}>
                                {error}
                            </div>
                        )}
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <SubmitCancelButtons
                    loading={loading}
                    onSubmit={handleSave}
                    onCancel={handleClose}
                    hideCancel={false}
                    cancelText="Cancel"
                />
            </Modal.Actions>
        </StyledModal>
    )
}

export default TemplateNameModal
